import JSONPointerEvaluateError from "./JSONPointerEvaluateError.mjs";
class JSONPointerTypeError extends JSONPointerEvaluateError {}
export default JSONPointerTypeError;